package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository

class GetCharactersUseCase(
    private val characterRepository: CharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    /**
     * @param withSignedAvatars quand `false`, la signature des avatars est entièrement sautée.
     * Chaque avatar coûte un aller-retour réseau, donc les écrans qui n'affichent que des noms
     * (sélection d'un personnage existant pour une table) doivent passer `false`.
     */
    suspend operator fun invoke(
        universeId: String,
        userId: String,
        withSignedAvatars: Boolean = true
    ): Result<List<Character>> {
        return characterRepository.getCharactersByUserId(universeId, userId)
            .map { characters ->
                if (!withSignedAvatars) {
                    return@map characters.sortedByDescending { it.createdAt }
                }
                characters.map { character ->
                    // Generate signed URL for characters with image paths
                    if (character.imageUrl != null) {
                        val signedUrlResult = imageStorageRepository.getSignedUrl(
                            character.imageUrl,
                            version = character.updatedAt.toString()
                        )
                        if (signedUrlResult.isSuccess) {
                            character.copy(signedImageUrl = signedUrlResult.getOrThrow())
                        } else {
                            character
                        }
                    } else {
                        character
                    }
                }.sortedByDescending { it.createdAt }
            }
    }
}
